import { BaseService } from './core/BaseService';

/** 套餐信息（GET /api/plans 契约，积分系统开发方案 v1.10 6.2；P1 定价表留空灰度） */
export interface PlanInfo {
  plan: string;
  label: string;
  period: string;
  grantCredits: number;
  bonusCredits: number;
  grantPeriods: number;
  /** 单期发放基准额（服务端按剩余整期数折算的实际口径） */
  perPeriodCredits: number;
  priceCents: number;
  originalPriceCents: number | null;
  concurrency: number;
  isActive: boolean;
}

/** 积分流水项（GET /api/credits/ledger items，文档 6.4） */
export interface LedgerItem {
  id: string;
  /** grant_daily / grant_period / consume / refund / clear_daily / manual_adjust */
  ledgerType: string;
  /** 正=入账，负=扣减 */
  amount: number;
  balanceAfter: number;
  refId: string | null;
  modelId: string | null;
  reason: string | null;
  createdAt: string | null;
}

export interface LedgerResult {
  total: number;
  page: number;
  size: number;
  items: LedgerItem[];
}

/** 兑换码核销结果（POST /api/redeem）：plan 型开通套餐 / credits 型直充积分 */
export interface RedeemResult {
  message: string;
  /** plan = 开通套餐（planKey/granted）｜ credits = 直充积分（credits/balance） */
  redeemType: 'plan' | 'credits';
  planKey?: string | null;
  granted?: number | null;
  credits?: number | null;
  balance?: number | null;
}

class CreditsApiService extends BaseService {
  /** 套餐列表（公开接口，仅上架，priceCents 升序） */
  async getPlans(): Promise<PlanInfo[]> {
    return this.get<PlanInfo[]>('/api/plans');
  }

  /** 本人积分流水（JWT 鉴权，分页；ledgerType 可选服务端筛选，空 = 全部） */
  async getLedger(page = 1, size = 20, ledgerType?: string): Promise<LedgerResult> {
    const typeQuery = ledgerType ? `&ledgerType=${encodeURIComponent(ledgerType)}` : '';
    return this.get<LedgerResult>(`/api/credits/ledger?page=${page}&size=${size}${typeQuery}`);
  }

  /** 兑换码核销（JWT 鉴权）：plan 型开通套餐 / credits 型直充积分 */
  async redeem(code: string): Promise<RedeemResult> {
    return this.post<RedeemResult>('/api/redeem', { code });
  }
}

export const creditsApi = new CreditsApiService();
